import { useState } from "react";
import { Send } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { fmtDate } from "@/lib/api";

export function MessageThread({ messages, onSend, me = "student", extra, placeholder = "Write a message..." }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await onSend(text.trim());
      setText("");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-col gap-4" data-testid="message-thread">
      <div className="flex flex-col gap-3 max-h-[420px] overflow-y-auto pr-1">
        {messages.length === 0 && <p className="text-sm text-slate-500" data-testid="message-empty">No messages yet.</p>}
        {messages.map((m) => (
          <div key={m.id} className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm ${m.sender === me ? "self-end bg-[#0B2A4A] text-[#F5ECD7]" : "self-start bg-white border border-[#0B2A4A]/10"}`} data-testid="message-bubble">
            <p className="whitespace-pre-wrap">{m.body}</p>
            <p className="mt-1 text-[10px] opacity-60 font-mono-ui">
              {m.sender === "host" ? "Mr. Greg" : "Student"} · {m.via === "email" ? "sent by email · " : ""}{fmtDate(m.created_at)}
            </p>
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="flex flex-col gap-2">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} rows={3} data-testid="message-input" />
        <div className="flex flex-wrap items-center justify-between gap-3">
          {extra}
          <button disabled={busy} className="ml-auto inline-flex items-center gap-2 rounded-xl bg-[#1A9AA8] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#147C88] disabled:opacity-50" data-testid="message-send-btn">
            <Send className="h-4 w-4" /> {busy ? "Sending..." : "Send"}
          </button>
        </div>
      </form>
    </div>
  );
}
